import { SHAPE, FIT } from "three-ammo/constants";

AFRAME.registerComponent("shape-helper", {
  schema: {
    type: {
      default: SHAPE.HULL,
      oneOf: [
        SHAPE.BOX,
        SHAPE.CYLINDER,
        SHAPE.SPHERE,
        SHAPE.CAPSULE,
        SHAPE.CONE,
        SHAPE.HULL,
        SHAPE.HACD,
        SHAPE.VHACD,
        SHAPE.MESH,
        SHAPE.HEIGHTFIELD
      ]
    },
    fit: { default: FIT.ALL, oneOf: [FIT.ALL, FIT.MANUAL] },
    halfExtents: { type: "vec3", default: { x: 1, y: 1, z: 1 } },
    minHalfExtent: { default: 0 },
    maxHalfExtent: { default: Number.POSITIVE_INFINITY },
    sphereRadius: { default: NaN },
    cylinderAxis: { default: "y", oneOf: ["x", "y", "z"] },
    margin: { default: 0.01 },
    offset: { type: "vec3", default: { x: 0, y: 0, z: 0 } },
    orientation: { type: "vec4", default: { x: 0, y: 0, z: 0, w: 1 } },
    heightfieldData: { default: [] },
    heightfieldDistance: { default: 1 },
    includeInvisible: { default: false },
    debug: { default: false }
  },

  multiple: true,

  init: function () {
    this.system = this.el.sceneEl.systems["hubs-systems"].physicsSystem;
    this.uuid = -1;
    this.mesh = null;
    this.debugMesh = null;

    let bodyEl = this.el;
    this.bodyHelper = bodyEl.components["body-helper"] || null;
    while (!this.bodyHelper && bodyEl.parentNode != this.el.sceneEl) {
      bodyEl = bodyEl.parentNode;
      if (bodyEl.components["body-helper"]) {
        this.bodyHelper = bodyEl.components["body-helper"];
      }
    }
    if (!this.bodyHelper || this.bodyHelper.uuid === null || this.bodyHelper.uuid === undefined) {
      console.error("body not found");
      return;
    }
    if (this.data.fit === FIT.ALL) {
      if (!this.el.object3DMap.mesh) {
        console.error("Cannot use FIT.ALL without object3DMap.mesh");
        return;
      }
      this.mesh = this.el.object3DMap.mesh;
      this.mesh.updateMatrices();
    }

    this.uuid = this.system.addShapes(this.bodyHelper.uuid, this.mesh, this.data);

    if (this.data.debug) {
      this.createDebugShape();
    }
  },

  createDebugShape: function () {
    if (this.debugMesh) {
      this.el.removeObject3D("debug");
    }

    let geometry;
    const material = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true });

    switch (this.data.type) {
      case SHAPE.BOX:
        geometry = new THREE.BoxGeometry(
          this.data.halfExtents.x * 2,
          this.data.halfExtents.y * 2,
          this.data.halfExtents.z * 2
        );
        break;
      case SHAPE.SPHERE:
        geometry = new THREE.SphereGeometry(this.data.sphereRadius || 1);
        break;
      case SHAPE.CYLINDER:
        geometry = new THREE.CylinderGeometry(1, 1, 2, 32);
        break;
      default:
        geometry = new THREE.BoxGeometry(0.1, 0.1, 0.1);
    }

    this.debugMesh = new THREE.Mesh(geometry, material);
    this.debugMesh.position.copy(this.data.offset);
    this.debugMesh.quaternion.set(
      this.data.orientation.x,
      this.data.orientation.y,
      this.data.orientation.z,
      this.data.orientation.w
    );
    this.el.setObject3D("debug", this.debugMesh);
  },

  remove: function () {
    if (this.uuid !== -1 && this.bodyHelper.alive) {
      this.system.removeShapes(this.bodyHelper.uuid, this.uuid);
    }
    if (this.debugMesh) {
      this.el.removeObject3D("debug");
      this.debugMesh = null;
    }
  },

  update: function (oldData) {
    if (this.data.debug !== oldData.debug) {
      if (this.data.debug) {
        this.createDebugShape();
      } else if (this.debugMesh) {
        this.el.removeObject3D("debug");
        this.debugMesh = null;
      }
    }
  }
});
